export const label = 'font-medium block text-base font-body text-textMid';
export const dialogContent = 'h-full';
export const levelsDisplay = 'p-4 h-full overflow-y-auto';
